import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '../../store/useAuthStore';
import { loginUrl } from '../../util/url';
import Loading from '../loading/Loading';

/**
 * 인증(authn) 전용 라우트 가드.
 *
 * AutoLogin이 저장된 토큰으로 세션 복원을 끝낼 때까지 authStatus는 'loading'이며,
 * 이 동안에는 리다이렉트하지 않고 대기한다(새로고침 시 로그인 사용자가 튕기는 것을 방지).
 * 판정이 끝나면 authenticated → children, 그 외(anonymous | error) → 로그인 페이지.
 *
 * 권한(authz: 셀러/사업자 여부 등)은 이 컴포넌트가 다루지 않으므로 각 페이지에서 처리한다.
 */
export default function RequireAuth({ children }) {
    const authStatus = useAuthStore((state) => state.authStatus);
    const location = useLocation();

    if (authStatus === 'loading') return <Loading />;
    if (authStatus === 'authenticated') return children;

    return <Navigate to={loginUrl()} replace state={{ from: location }} />;
}

RequireAuth.propTypes = {
    children: PropTypes.node,
};
